import { render } from "./AltersAbteilung.vue?vue&type=template&id=17a57fe5&scoped=true"
import script from "./AltersAbteilung.vue?vue&type=script&lang=js"
export * from "./AltersAbteilung.vue?vue&type=script&lang=js"

import "./AltersAbteilung.vue?vue&type=style&index=0&id=17a57fe5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Florian\\Desktop\\FeuerwehrWeb3\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17a57fe5"]])

export default __exports__